import Highcharts from 'highcharts';
import { getEmploymentData } from "./chart-salaries";

/**
 * @param {string} id
 */
export default function chartVacancies(id) {
    if (!document.getElementById(id)) return;

    const cityData = getEmploymentData()
        .filter(item => item.filledGuards > 0)
        .sort((a, b) => b.vacancyRate - a.vacancyRate);

    const categories = cityData.map(item => item.city);
    const filledData = cityData.map(item => item.filledGuards);
    const vacantData = cityData.map(item => item.vacantGuards);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Filled posts and vacancies in city guards' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Number of posts' },
            reversedStacks: false
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: { enabled: false }
            }
        },
        legend: { reversed: true },
        credits: { enabled: false },
        series: [{
            name: 'Filled posts',
            data: filledData,
            color: '#3498db'
        }, {
            name: 'Vacancies',
            data: vacantData,
            color: '#e74c3c',
            dataLabels: {
                enabled: true,
                inside: false,
                align: 'left',
                x: 5,
                format: '{point.percentage:.0f}%',
                style: { color: '#000', textOutline: 'none', fontSize: '12px' },
                crop: false,
                overflow: 'allow'
            }
        }]
    });
}
